(function () {
    'use strict';

    window.initTabs = function () {
      // Get all the tab groups on the page
      const tabGroups = document.querySelectorAll("[data-tab-group]");
    
      // Function to set the active tab for a given tab group
      function setActiveTab(tabGroup, tabName) {
        // Get the tabs nav and content for this tab group
        const tabsNav = tabGroup.querySelector("[data-tab-nav]");
        const tabsContent = tabGroup.querySelector("[data-tab-content]");
    
        // Remove the active class from all tab nav items and content panes
        tabsNav.querySelectorAll("[data-tab]").forEach((tabNavItem) => {
          tabNavItem.classList.remove("active");
        });
    
        tabsContent.querySelectorAll("[data-tab-panel]").forEach((tabPane) => {
          tabPane.classList.remove("active");
        });
    
        // Add the active class to the selected tab nav item and content pane
        const selectedTabNavItem = tabsNav.querySelector(`[data-tab="${tabName}"]`);
        selectedTabNavItem.classList.add("active");
        const selectedTabPane = tabsContent.querySelector(
          `[data-tab-panel="${tabName}"]`
        );
        selectedTabPane.classList.add("active");
      }
    
      // Loop through each tab group
      tabGroups.forEach((tabGroup) => {
        // Get the tabs nav and content for this tab group
        const tabsNav = tabGroup.querySelector("[data-tab-nav]");
        const tabsNavItem = tabsNav.querySelectorAll("[data-tab]");
    
        // Get the active tab index from URL, or local storage, or default to 0 if not set      
        const url = new URL(window.location.href);
        const form = url.searchParams.get("formular");
        
        let activeTabName = 0;

        if (form) {
          tabsNavItem.forEach((tabNavItem, index) => {
            if (tabNavItem.getAttribute("data-tab-url") == form) {
              activeTabName = index;
            }
          });
        } else {
          const storedTab = localStorage.getItem(`activeTabName-${tabGroup.dataset.tabGroup}`);

          if (storedTab) {
            activeTabName = storedTab;
          }
        }

        activeTabName >= tabsNavItem.length ? activeTabName = 0 : null
              
        // Set the active tab
        setActiveTab(tabGroup, activeTabName);
    
        // Add a click event listener to each tab nav item
        tabsNavItem.forEach((tabNavItem) => {
          tabNavItem.addEventListener("click", () => {
            // Get the index of the clicked tab nav item
            const tabName = tabNavItem.dataset.tab;
            setActiveTab(tabGroup, tabName);

            /*
            let url = new URL(window.location.href);
            url.searchParams.delete("formular");
            history.pushState(null, '', url);
            */
    
            // Save the active tab index to local storage
            localStorage.setItem(
              `activeTabName-${tabGroup.dataset.tabGroup}`,
              tabName
            );
          });
        });
      });
    }

    initTabs();
  })();
  